import { createContext, useContext, useEffect, useState } from "react"
import { jwtDecode } from "jwt-decode"
import { handleLogout } from '@store/actions/auth'
import { useDispatch, useSelector } from 'react-redux'
import { getProfile } from '@src/store/authentication/actions/index.js'
import { isPosPath } from '@src/auth/posAuth'
import { isDetailingPath } from '@src/auth/detailingAuth'

const AuthContext = createContext()

const getClinicoAccessToken = () => {
  const token = localStorage.getItem('accessToken')
  if (!token || token === 'null' || token === 'undefined') return null
  return token
}

export const AuthProvider = ({ children }) => {
    const dispatch = useDispatch()
    const [isLoggedIn, setLoggedIn] = useState(true)    
    const [user, setUser] = useState(null)    
    const authentication = useSelector(state => state.authentication)

    useEffect(() => {        
        if (authentication.account) {                
            setUser(authentication.account)
        }        
    }, [authentication.account]) 

    useEffect(() => {
      // POS / Detailing use separate session keys — do not hit Clinico /accounts
      const path = window.location.pathname
      if (isPosPath(path) || isDetailingPath(path)) return
      if (!getClinicoAccessToken()) return
      dispatch(getProfile())
    }, [dispatch])

    useEffect(() => {
        const path = window.location.pathname
        if (isPosPath(path) || isDetailingPath(path)) return
        if (!getClinicoAccessToken()) return

        dispatch(getProfile()).then(data => {            
            setUser({ data })
          }).catch(() => {})

        let timerId

        const scheduledLoopAction = () => {
            const accessToken = getClinicoAccessToken()
            if (accessToken) {                
                try {
                  const decoded = jwtDecode(accessToken)                

                  if (decoded.exp && decoded.exp * 1000 < Date.now()) {                    
                      dispatch(handleLogout())
                      setLoggedIn(false)                      
                  } else {                    
                      setLoggedIn(true)                    
                  }
                } catch {
                  // ignore bad token
                }

                timerId = setTimeout(scheduledLoopAction, 1 * 1000)
            }            
        }

        timerId = setTimeout(scheduledLoopAction, 1 * 1000)

        return () => {
            clearTimeout(timerId)
        }
    }, [])

    return (
        <AuthContext.Provider value={{ isLoggedIn, user }}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => useContext(AuthContext)
